module.exports = __webpack_public_path__ + "img/icon2.d7346084.png";